import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { listsMappedProps } from 'app/shapes/browse/rows';
import ListsHero from './ListsHero';

const ListsHeroContainer = props => {
  const library = useSelector(selectCurrentLibrary);

  return <ListsHero {...props} library={library} />;
};

ListsHeroContainer.defaultProps = {
  additionalAnalyticsPayload: {}
};

ListsHeroContainer.propTypes = {
  ...listsMappedProps,
  additionalAnalyticsPayload: PropTypes.object,
  trackListCreatorClick: PropTypes.func.isRequired,
  trackListImageClick: PropTypes.func.isRequired,
  trackListImpression: PropTypes.func.isRequired,
  trackListTitleClick: PropTypes.func.isRequired
};

export default ListsHeroContainer;
